<template>
<div class="odr-acknowledgement">
    <div class="odr-checkbox">
        <input type="checkbox"
               ref="input"
               class="odr-checkbox__input"
               v-model="checked"
               @change="handleCheckboxChange"
               :disabled="isDisabled">
        <div class="odr-checkbox__control">
            <svg class="odr-svg" viewBox="0 0 24 24">
                <path class="odr-checkbox__checkmark"
                      fill="none"
                      stroke="white"
                      d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
            </svg>
        </div>
    </div>
    <span><slot></slot></span>
</div>
</template>

<script>

import { mapGetters } from 'vuex';
import '@/scss/blocks/acknowledgement.scss';
import { AuditEvent, EventStatus } from '@/types/AuditEvent';
import audit from '@/utils/mixins/audit';

export default {
    mixins: [audit],
    props: {
        name: {
            type: String,
            required: true,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
        require: {
            type: String,
            default: 'false',
        },
        'error-message': {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            checked: false,
            isDisabled: false,
        };
    },
    created () {
        const acknowledgement = this.getAcknowledgement(this.name);
        this.checked = acknowledgement.acknowledged || false;
        this.isDisabled = this.checked;
        this.setAcknowledgementData();
    },
    methods: {
        handleCheckboxChange () {
            if (this.checked) {
                this.isDisabled = true;
            }
            this.setAcknowledgementData();
            this.trackAuditEvent();
        },
        setAcknowledgementData () {
            const errorMessage = this.errorMessage ? this.errorMessage : `${this.$trl('aw.acknowledgement_error_message')} ${this.name}`;
            this.$store.dispatch('flow/SET_ACKNOWLEDGEMENT', {
                name: this.name,
                acknowledged: this.checked,
                require: this.require === 'true',
                showError: false,
                eMessage: errorMessage,
            });
        },
        trackAuditEvent () {
            const event = new AuditEvent({
                eventType: this.type,
                eventStatus: EventStatus.SUCCESS,
                isAcknowledgementEvent: true,
            });
            this.trackPrivateAudit(event);
        },
    },
    computed: {
        ...mapGetters('flow', {
            getAcknowledgement: 'getAcknowledgement',
        }),
    },
};
</script>
